import { render, staticRenderFns } from "./ripple.vue?vue&type=template&id=25dc19c8&"
import script from "./ripple.vue?vue&type=script&lang=ts&"
export * from "./ripple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports